module.exports = __webpack_public_path__ + "static/media/google-icon.86b5e6bd.svg";